import React from 'react';

import MainRoutes from './routes';

import GlobalStyles from './styles/Global';

function App () {
  return (
    <>
      <MainRoutes />
      <GlobalStyles />
    </>
  );
}

export default App;
